const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogAnoSerie(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoSerie`, params);
    },
    $obterRelatorioLogCSVAnoSerie(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoSerieCsv`, params);
    },
    $obterRelatorioLogPDFAnoSerie(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoSeriePdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
